import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { FileFilters } from '@/features/files/types/file.types';
import type { SortingState } from '@tanstack/react-table';

interface FilesState {
  currentPage: number;
  pageSize: number;
  searchValue: string;
  onlyMyDocs: boolean;
  filters: FileFilters[];
  sorting: SortingState;
}

const initialState: FilesState = {
  currentPage: 0,
  pageSize: 10,
  searchValue: '',
  onlyMyDocs: true,
  filters: [],
  sorting: [],
};

const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setSearchValue: (state, action: PayloadAction<string>) => {
      state.searchValue = action.payload;
    },
    setOnlyMyDocs: (state, action: PayloadAction<boolean>) => {
      state.onlyMyDocs = action.payload;
    },
    setFilters: (state, action: PayloadAction<FileFilters[]>) => {
      state.filters = [...action.payload].sort();
    },
    toggleFilter: (state, action: PayloadAction<FileFilters>) => {
      const index = state.filters.indexOf(action.payload);
      if (index === -1) {
        state.filters.push(action.payload);
      } else {
        state.filters.splice(index, 1);
      }
      state.filters.sort();
    },
    resetFilters: (state) => {
      state.filters = [];
    },
    setSorting: (state, action: PayloadAction<SortingState>) => {
      state.sorting = action.payload;
    },
  },
});

export const {
  setCurrentPage,
  setPageSize,
  setSearchValue,
  setOnlyMyDocs,
  setFilters,
  toggleFilter,
  resetFilters,
  setSorting,
} = filesSlice.actions;

export default filesSlice.reducer;
